import type { Easing } from 'framer-motion';

export const BASE_DURATION = 0.2;
export const BASE_FADEIN_DURATION = 0.2 * 2;
export const DEFAULT_EASE: Easing = [0.4, 0, 0.2, 1] as const;
export const DEFAULT_DELAY = 0.1;
export const BASE_Y = 5;

export const defaultFadeInProps = {
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  initial: { opacity: 0 },
  transition: {
    duration: BASE_FADEIN_DURATION,
    ease: DEFAULT_EASE,
  },
};

export const getFadeInAndUpProps = ({
  startingY = BASE_Y,
  duration = BASE_FADEIN_DURATION,
  delay = 0,
}: {
  startingY?: number;
  duration?: number;
  delay?: number;
}) => ({
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: startingY },
  initial: { opacity: 0, y: startingY },
  transition: {
    duration,
    ease: DEFAULT_EASE,
    delay,
  },
});
